import React, { useRef, useEffect, useState } from 'react';
import './WhyChooseUs.css';

const REASONS = [
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M12 2L2 7l10 5 10-5-10-5z"/>
        <path d="M2 17l10 5 10-5"/>
        <path d="M2 12l10 5 10-5"/>
      </svg>
    ),
    title: 'Specialized ATE & Probe Card Expertise',
    desc: 'One of the only PCB design firms globally specializing in ATE, Probe Cards and Application Boards — a niche few can match.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="10"/>
        <polyline points="12 6 12 12 16 14"/>
      </svg>
    ),
    title: '24/7 Global Support',
    desc: 'Round-the-clock engineering support across time zones. Our customers are never left waiting — we respond when it matters most.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
        <polyline points="22 4 12 14.01 9 11.01"/>
      </svg>
    ),
    title: 'Zero Compromise Quality',
    desc: 'Highest-grade IPC Class 3 standards with rigorous DFM/DFT checks. Production-ready designs from day one, every time.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    title: 'Equal Value for Every Client',
    desc: 'Startups or Fortune 500s — every client gets the same senior engineering attention, dedicated project management and transparent communication.',
  },
 {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/>
      </svg>
    ),
    title: 'Mechanical Divisions',
    desc: 'Dedicated mechanical engineering divisions supporting enclosure design, thermal management, and PCB stack-up planning — bridging the gap between electronics and physical product.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="3"/>
        <path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/>
      </svg>
    ),
    title: 'End-to-End Delivery',
    desc: 'From schematic capture and simulation to fabrication, assembly and procurement — we are your single-source engineering partner.',
  },
];

function UseCard({ reason, index }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.12 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`wcu-card${visible ? ' wcu-card--visible' : ''}`}
      style={{ transitionDelay: `${index * 0.08}s` }}
    >
      <div className="wcu-card-icon">{reason.icon}</div>
      <h3 className="wcu-card-title">{reason.title}</h3>
      <p className="wcu-card-desc">{reason.desc}</p>
      <div className="wcu-card-line" />
    </div>
  );
}

export default function WhyChooseUs() {
  return (
    <section className="wcu-section">
      {/* Background decoration */}
      <div className="wcu-bg-orb wcu-bg-orb-1" />
      <div className="wcu-bg-orb wcu-bg-orb-2" />

      <div className="wcu-inner">
        <div className="wcu-header reveal">
          <div className="section-tag">Why Choose DWB Tech</div>
          <h2 className="wcu-heading">
            Our Core Capabilities —{' '}
            <span className="gradient-text">Built For Your Success</span>
          </h2>
          <p className="wcu-sub">
            With 32+ years of specialized experience, DWB Tech delivers engineering excellence
            that larger firms simply can't match at our speed, precision, and price point.
          </p>
        </div>

        <div className="wcu-grid">
          {REASONS.map((r, i) => (
            <UseCard key={r.title} reason={r} index={i} />
          ))}
        </div>

        
      </div>
    </section>
  );
}
